<template>
  <div>
    <div v-for="(item, index) in value" :key="index">
      <v-row align="center">
        <v-col cols="9">
          <v-text-field
            outlined
            single-line
            dense
            hide-details="auto"
            v-model="item.email"
            :placeholder="placeholder"
            @input="update_start_time_value($event, index)"
            :rules="[
              () => !!item.email || 'Email is required',
              () => validate_email(item.email) || 'E-mail must be valid',
            ]"
          ></v-text-field>
        </v-col>
        <v-col
          cols="1"
          xs="1"
          sm="1"
          md="1"
          lg="1"
          xl="1"
          v-if="multiple && item.email != '' && value.length > 1"
        >
          <div @click="remove_date_time(index)">
            <v-icon color="error">mdi-minus-circle-outline</v-icon>
          </div>
        </v-col>
        <v-col
          cols="1"
          xs="1"
          sm="1"
          md="1"
          lg="1"
          xl="1"
          v-if="item.email != '' && multiple"
        >
          <div
            @click="add_date_time(index)"
            v-if="value.length == index + 1 && multiple"
          >
            <v-icon color="success">mdi-plus-circle-outline</v-icon>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    is_required: Boolean,
    value: Array,
    placeholder: String,
    multiple: Boolean,
  },
  data: function () {
    return {
      email: null,
      selected_index: -1,
    };
  },
  methods: {
    validate_email(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    update_start_time_value(value, index) {
      this.selected_index = -1;
      this.$emit("update_start_time_value", {
        time: value,
        index: index,
      });
    },
    remove_date_time(index) {
      this.$emit("remove_date_time", index);
    },
    add_date_time(index) {
      this.$emit("add_date_time", index);
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
};
</script>

<style>
</style>